import React, { FC } from 'react';
import { Input, InputNumber, Select, Typography } from 'antd';
import { Property } from 'csstype';

export interface OptionedInputValue {
  option?: string;
  input?: string;
}

export interface OptionedInputProps {
  id?: string;
  options?: string[];
  values?: OptionedInputValue;
  onChange?: (value: OptionedInputValue | undefined) => void;
  placeholder?: string;
  inputType?: string;
  optionsWidth?: Property.Width<string>;
  enabled?: boolean;
  readonlyOptions?: boolean;
  readonlyInput?: boolean;
}

const getSelectWidthAddition = (
  optionsWidth?: string,
  enabled?: boolean,
  readonly?: boolean,
  value?: string,
  additionalOffset?: string,
) => {
  additionalOffset = additionalOffset || '0px';
  if (readonly || enabled === false) {
    if (!value) {
      return `0px`;
    } else {
      return `calc(${optionsWidth} - 30px - ${additionalOffset})`;
    }
  } else {
    return `calc(${optionsWidth} - 5px)`;
  }
};

type Props = OptionedInputProps;

const OptionedInput: FC<Props> = (props) => {
  const {
    values = {},
    options = [],
    optionsWidth = '70px',
    onChange,
    placeholder,
    inputType,
    enabled,
    readonlyOptions,
    readonlyInput,
  } = props;

  return (
    <div id={props.id}>
      {enabled === false || readonlyOptions ? (
        <Typography.Text
          style={{
            border: 'none',
            width: `calc(${optionsWidth} - 30px)`,
            boxShadow: 'none',
            position: 'absolute',
            zIndex: 9999,
            height: '32px',
            alignContent: 'center',
            textAlign: 'center',
            color: '#888888',
            cursor: 'default',
            visibility: values.option ? 'visible' : 'hidden',
          }}
        >
          {values.option}
        </Typography.Text>
      ) : (
        <Select
          value={values.option}
          onChange={(selected) =>
            onChange?.({
              ...values,
              option: selected.toString(),
            })
          }
          style={{
            border: 'none',
            width: optionsWidth,
            boxShadow: 'none',
            position: 'absolute',
            zIndex: 9999,
            backgroundColor: 'wheat',
          }}
          variant="borderless"
        >
          {options.map((option) => (
            <Select.Option
              key={option}
              value={option}
              style={{ border: 'none' }}
            >
              {option}
            </Select.Option>
          ))}
        </Select>
      )}

      {inputType !== 'price' ? (
        <Input
          disabled={enabled === false}
          readOnly={readonlyInput ?? false}
          type={inputType || 'text'}
          value={values.input}
          onChange={(e) =>
            onChange?.({
              ...values,
              input: e.target.value,
            })
          }
          style={{
            paddingLeft: getSelectWidthAddition(
              optionsWidth,
              enabled,
              readonlyOptions,
              values.option,
              '0px',
            ),
            width: '100%',
          }}
          placeholder={placeholder}
        />
      ) : (
        <InputNumber
          disabled={enabled === false}
          readOnly={readonlyInput ?? false}
          precision={2}
          min={0.01}
          value={
            values.input ? parseFloat(values.input || '0') / 100 : undefined
          }
          onChange={(e) =>
            onChange?.({
              ...values,
              input:
                e !== undefined && e !== null
                  ? Math.round(e * 100).toString()
                  : undefined,
            })
          }
          style={{
            paddingLeft: getSelectWidthAddition(
              optionsWidth,
              enabled,
              readonlyOptions,
              values.option,
              '10px',
            ),
            width: '100%',
          }}
          placeholder={placeholder}
        />
      )}
    </div>
  );
};

export default OptionedInput;
